import { MdLocationOn, MdEmail, MdPhone } from "react-icons/md";

export default function ContactUsContent() {
  return (
    <div className="MainBodySection py-5">
      <div className="container">
        <div className="row justify-content-center">

          {/* Header */}
          <div className="col-md-12 text-center mb-4">
            <h6 className="main-section-title">CONTACT US</h6>
            <p className="text-dim" style={{ maxWidth: "850px", margin: "0 auto" }}>
               Whether you are planning a building project, infrastructure development,
              or renovation, our construction experts are ready to provide professional
              guidance, project planning, and execution support. Reach out through any
              of the channels below.
            </p>
          </div>

          {/* Contact Cards */}
          <div className="col-md-10 col-lg-8">
            <div className="row g-4">

              {/* Address */}
              <div className="col-md-4">
                <a
                  href="https://www.google.com/maps/search/?api=1&query=Dar+es+Salaam+Tanzania"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-decoration-none"
                >
                  <div className="bg-white p-4 rounded-4 mShadow2 h-100 text-center">
                    <MdLocationOn size={36} className="mb-3 text-primary" />
                    <h6 className="font-semi-bold mb-2">Address</h6>
                    <p className="text-dim mb-0">
                      P. O. Box 72144<br />
                      Dar es Salaam, Tanzania<br />
                      East Africa
                    </p>
                  </div>
                </a>
              </div>

              {/* Email */}
              <div className="col-md-4">
                <a
                  href="mailto:jengaconstruction1@gmail.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-decoration-none"
                >
                  <div className="bg-white p-4 rounded-4 mShadow2 h-100 text-center">
                    <MdEmail size={36} className="mb-3 text-primary" />
                    <h6 className="font-semi-bold mb-2">Email</h6>
                    <p className="text-dim text-center">
                      info@jengaconstruction.co.tz
                    </p>
                  </div>
                </a>
              </div>

              {/* Phone */}
              <div className="col-md-4">
                <a
                  href="tel:+255774544444"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-decoration-none"
                >
                  <div className="bg-white p-4 rounded-4 mShadow2 h-100 text-center">
                    <MdPhone size={36} className="mb-3 text-primary" />
                    <h6 className="font-semi-bold mb-2">Phone</h6>
                    <p className="text-dim mb-0">
                      +255 774 544444<br />
                      +255 787 449211
                    </p>
					<span style={{fontSize: "12px"}}>Click to chat on WhatsApp</span>
                  </div>
                </a>
              </div>

            </div>
          </div>

        </div>
      </div>
    </div>
  );
}
